import React from 'react';

const IconRotate = () => {
  return (
    <div>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.00008 0.666504C13.6026 0.666504 17.3334 4.39734 17.3334 8.99984C17.3334 13.6023 13.6026 17.3332 9.00008 17.3332C4.39758 17.3332 0.666748 13.6023 0.666748 8.99984H2.33341C2.33341 12.6815 5.31841 15.6665 9.00008 15.6665C12.6817 15.6665 15.6667 12.6815 15.6667 8.99984C15.6667 5.31817 12.6817 2.33317 9.00008 2.33317C6.94675 2.33317 5.11008 3.2615 3.88758 4.72067L5.66675 6.49984H0.666748V1.49984L2.70591 3.53817C4.23341 1.77984 6.48675 0.666504 9.00008 0.666504ZM9.83341 4.83317V8.654L12.5359 11.3565L11.3567 12.5357L8.16675 9.344V4.83317H9.83341Z"
          fill="#7E92B0"
        />
      </svg>
    </div>
  );
};

export default IconRotate;
